import * as React from "react";
import SwitchHybrid from "./SwitchHybrid";
import type { TypeSwitchProps } from "./SwitchTypes";

/**
 * @link https://seeds.sproutsocial.com/components/switch/
 *
 * Switch should always have an accessible label. Use aria-label, aria-labelledby or a `Label` component.
 * The accessible label should not change when the checked state changes.
 * The component uses role="switch" and the `checked` prop will be used to set the aria-checked attribute.
 *
 * @see https://www.w3.org/WAI/ARIA/apg/patterns/switch/
 *
 * @example
 * <Switch checked={true} onClick={_onClick} aria-label="Switch Example" />
 *
 * Automatically routes between the Tailwind implementation (preferred) and the
 * styled-components implementation (for consumers using system props or styled() extension).
 */
const Switch = React.forwardRef<HTMLButtonElement, TypeSwitchProps>(
  (props, ref) => <SwitchHybrid {...props} ref={ref} />
);

Switch.displayName = "Switch";
export default Switch;
